module.exports = __webpack_public_path__ + "static/img/保险公司名单@2x.26d8990.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/gjyxb/assets/ch/保险公司名单@2x.png
// module id = 1487
// module chunks = 363